import React, { useContext, useState } from "react";
import { ApiLinkContext } from "../context/ApiLinkContext";
import { LanguageContext } from "../context/LanguageContext";
import { NavLink, useNavigate } from "react-router-dom";
import slugify from "react-slugify";
import translations from "../data/langData";

const New = () => {
  const { blog } = useContext(ApiLinkContext);
  const [visible, setVisible] = useState(20);
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const navigate = useNavigate()
  return (
    <>
      <div className="news">
        <div className="container">
          <div className="section-title">
            <h2 className="title text-center">
              {/* {findCatName && findCatName.name} */}
            </h2>
          </div>
          <div className="row">
            {blog.length > 0 &&
              blog.slice(0, visible).map((item) => {
                return (
                  <div className="col-lg-4 col-sm-6 col-12">
                    <NavLink
                      onClick={()=>{
                        navigate(`/${slugify(
                          `${item.id}-${item.name}`
                        ).toLowerCase()}`)
                        window.location.reload()
                      }}
                    >
                      <div className="swiper-s mb-30 mx-2 pb-5">
                        <div className="course box-shadow">
                          <div className="thumbnail">
                            <a href="#" className="image">
                              <img
                                src={item.img}
                                alt="Course Image"
                                id="newsImg"
                              />
                            </a>
                          </div>
                          <div className="info">
                            <h3 className="title">
                              <a href="#">
                                {language == "az"
                                  ? item.name
                                  : language == "en"
                                  ? item.nameEn
                                  : language == "ru"
                                  ? item.nameRu
                                  : language == "tr"
                                  ? item.nameTr
                                  : language == "de"
                                  ? item.nameDe
                                  : language == "pl"
                                  ? item.namePl
                                  : ""}
                              </a>
                            </h3>
                            <p>
                              {item.descrip && 
                              
                              language == "az"
                                      ? item.descrip
                                      : language == "en"
                                      ? item.descripEn
                                      : language == "ru"
                                      ? item.descripRu
                                      : language == "tr"
                                      ? item.descripTr
                                      : language == "de"
                                      ? item.descripDe
                                      : language == "pl"
                                      ? item.descripPl
                                      : ""}
                              
                              ...
                            </p>
                            <ul className="meta">
                              <li>
                                <i className="fas fa-file-alt" />
                                {item.date}
                              </li>
                              <li>
                                <i className="fas fa-user-alt" />
                                {item.view} view
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                );
              })}
          </div>
          {visible < blog.length && (
            <div className="d-flex justify-content-center align-items-center mb-5">
              <button
                className="btn btn-success"
                style={{ textTransform: "uppercase" }}
                onClick={() => setVisible((prevState) => prevState + 10)}
              >
                {t.more}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default New;
